import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { SelectedFilters } from '../../types/filters.type';
import { CreateFilterTemplateRequest, FilterTemplate } from '../../api-models';
import adaptFilterRequest from './adaptFilterRequest';

export default class PostCreateFilterTemplate extends BaseAdapter<FilterTemplate> implements AdapterInterface {
  rawResponse: FilterTemplate;

  modifiedRequest: CreateFilterTemplateRequest;

  async adaptResponse(request: { templateName: string, selectedFilters: SelectedFilters }): Promise<FilterTemplate> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/create-filter-template', HTTPMethod.Post, formattedRequest);
    return this.rawResponse;
  }

  adaptRequest(request: { templateName: string, selectedFilters: SelectedFilters }): CreateFilterTemplateRequest {
    const adaptedFilters = adaptFilterRequest(request.selectedFilters);

    this.modifiedRequest = {
      template_name: request.templateName,
      filter_request_list: adaptedFilters.filter_request_list,
    };

    return this.modifiedRequest;
  }
}
